import React, { useEffect, useRef, useState } from "react";
// import findyour from "../../assets/images/findyour.svg"
import submit from "../../../assets/images/submit.svg"

const FindYourSpace = () => {

   const triggerRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
  

    const textRef = useRef(null);
  
      // Intersection Observer for fade-in text
      useEffect(() => {
        const observer = new IntersectionObserver(
          ([entry]) => {
            setIsVisible(entry.isIntersecting); // Set visibility based on intersection
          },
          {
            threshold: 0.5, // Trigger when 50% of the element is visible
          }
        );
    
        const textElement = textRef.current;
        if (textElement) observer.observe(textElement);
    
        return () => {
          if (textElement) observer.unobserve(textElement);
        };
      }, []);



      useEffect(() => {
        // Ensure Typeform embed script is loaded
        const script = document.createElement('script');
        script.src = '//embed.typeform.com/next/embed.js';
        script.async = true;
        document.body.appendChild(script);
    
        return () => {
          document.body.removeChild(script);
        };
      }, []);
  return (

     <section className="check_list findyour_space">
          <div className="container">
           
    

            <div className="byb-checklist-header" ref={triggerRef}>
         
          <h2>
            <span className="d-inline d-lg-block d-sm-block  ">Find your Space for Collaboration at</span>
          </h2>
          <p ref={textRef}
              className={`lg_brand_txt fade-in-text ${isVisible ? "visible" : ""}`}>Brew Your Brand </p>
        </div>

    <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/findyour.svg" alt="Find your brand community space visual" className="center_img mx-auto d-block"  />
          <p className="text-center para_p p_txt">Connect with fellow Brand Enthusiasts,  Entrepreneurs, and Startups leaders, who share  your drive for creativity and innovation.  Exchange ideas, test hypotheses,  gather feedback, discover design tips,  learn marketing hacks, through an  ever-expanding pool of knowledge  within the community. 

                       <span className='lets_brew'> Let’s brew the brands of tomorrow!</span>    
                              </p>
                              <div className=" brand_self">
                                  <div data-tf-live="01JJV14J257ED52SCENJ77441Y" className="text-center position-relative"></div>
                            </div>
                    <button  className="blue_btn join_btn overlap_btn">Become a Member</button>

                    
    

          </div>

          {/* <div className='subscribe_form' >
          <div className="container">
                <div className="form_wrapper"  style={{background:"#05141e87"}}>
                            <div className="form_txt">
                                    <p className=' p_txt text-white mb-0'>Brand News as it happens Know what Brands are up to,  before it becomes old news. </p>
                            </div>

                            <div className="submit_form" >
                            <label htmlFor="submit">Subscribe To Our Newsletter</label>
                                <div className='form_sec'>
                                
                                        <input type="text" className='form-control' name="" id="submit" placeholder='Your email'/>
                                        <img src={submit} alt="Submit newsletter email" />
                                </div>
                            </div>
                </div>
                </div>
          </div> */}
    </section>
   
  )
}

export default FindYourSpace
